const PlayerBioStats = ({ playerBioStats }) => {
  return (
    <dl className="grid grid-cols-2 gap-x-4 gap-y-8">
      {playerBioStats.map((stat) => (
        <div key={stat.label} className="border-t-2 border-gray-100 pt-6">
          <dt className="text-base font-medium text-gray-500">{stat.label}</dt>
          <dd className="text-xl sm:text-2xl font-extrabold tracking-tight text-gray-900">
            {stat.value}
          </dd>
        </div>
      ))}
    </dl>
  );
};

export default PlayerBioStats;
